module.exports = __webpack_public_path__ + "img/良品率排行@3x.e814a626.png";